import { ReactElement } from "react";
import { IDimensions } from "./chartUtils";
import * as d3 from "d3";
import { TickTypes } from "./types";

interface IGridProps {
  charID: string;
  dimensions: IDimensions;
  xScale?: d3.ScaleLinear<number, number> | d3.ScaleBand<string>;
  yScale?: d3.ScaleLinear<number, number> | d3.ScaleBand<string>;
  xTicks?: TickTypes;
  yTicks?: TickTypes;
  index?: number;
}

const Grid = ({ charID, dimensions, xScale, yScale, xTicks, yTicks, index }: IGridProps): ReactElement => {
  const xLineID = `${charID}-grid-xAxis`;
  const yLineID = `${charID}-grid-yAxis`;
  const offset = (index ?? 0) * dimensions.boundedHeight + (index ?? 0) * 15;

  return (
    <g className="Axis AxisHorizontal" transform={`translate(0, ${offset})`}>
      <rect x={0} y={0} width={dimensions.boundedWidth} height={dimensions.boundedHeight} fill={"black"} fillOpacity={.2} className="Axis__line" />
      {xScale && xTicks && xTicks.map((tick, i) => {
        const x = xScale(tick as any) ?? 0;

        return (
          <line key={`${xLineID}-${i}`} className="Axis__line"
            y2={dimensions.boundedHeight}
            x1={x}
            x2={x}/>);
      })}

      {yScale && yTicks && yTicks.map((tick, i) => {
        const y = yScale(tick as any) ?? 0;

        return (
          <line key={`${yLineID}-${i}`} className="Axis__line"
            x2={dimensions.boundedWidth}
            y1={y}
            y2={y}/>);
      })}
    </g>
  );
};

export default Grid;
